module.exports = __webpack_public_path__ + "static/img/d2fe74f.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/lhsx/txgg_khzb.png
// module id = 649
// module chunks = 2